/**
 * CustomerMarker — Etapa 5 (P1-1: Modo Comercial).
 *
 * Cria um marker AGREGADO por cliente (Leaflet divIcon). Cor pelo status
 * dominante; mostra contagem de devices, rótulo do cliente e um badge com
 * o nº de alertas. SEM popup — clicar foca o cliente no painel/sheet.
 */
import { DOMINANT_COLOR } from "./customerGroups.js";

function esc(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Retorna um L.marker ou null (grupo sem coordenadas válidas). */
export function createCustomerMarker(L, group, { onClick, focused } = {}) {
  if (!group || group.lat == null || group.lng == null) return null;
  const color = DOMINANT_COLOR[group.dominant] || DOMINANT_COLOR.nodata;
  const badge =
    group.alerts > 0
      ? `<span class="ipwd-cust-badge">${group.alerts}</span>`
      : "";

  // P1-4 — classe por status dominante (glow/pulse) + foco.
  const cls = [
    "ipwd-cust-marker",
    `dom-${group.dominant}`,
    focused ? "is-focused" : "",
  ].filter(Boolean).join(" ");

  const html =
    `<div class="${cls}" style="--cc:${color}">` +
    `<span class="ipwd-cust-count">${group.total}</span>` +
    badge +
    `<span class="ipwd-cust-label">${esc(group.label)}</span>` +
    `</div>`;

  const icon = L.divIcon({
    className: "ipwd-cust-wrap",
    html,
    iconSize: [46, 46],
    iconAnchor: [23, 23],
  });

  const marker = L.marker([group.lat, group.lng], {
    icon,
    riseOnHover: true,
    zIndexOffset: group.alerts > 0 ? 400 : 0,
  });

  marker.bindTooltip(
    `${esc(group.label)} · ${group.total} dispositivo(s)`,
    { direction: "top", offset: [0, -16], className: "ipwd-marker-tooltip" },
  );

  if (onClick) marker.on("click", () => onClick(group.key));
  return marker;
}
